import { X } from "lucide-react";
import { Modal } from "@web/ui/Modal";
import { Shortcut } from "@web/ui/Kbd";
import { helpSections } from "./keymap";

export function ShortcutsHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { groups, paletteOnly } = helpSections();
  return (
    <Modal open={open} onClose={onClose} label="Keyboard shortcuts">
      <div className="flex items-center justify-between border-b border-line px-5 py-3">
        <h2 className="text-lg">Keyboard shortcuts</h2>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="rounded-md p-1 text-muted hover:bg-sunk hover:text-ink"
        >
          <X className="size-4" />
        </button>
      </div>
      <div className="max-h-[60vh] overflow-y-auto px-5 py-4">
        <div className="grid gap-5 sm:grid-cols-2">
          {groups.map(({ group, commands }) => (
            <section key={group}>
              <h3 className="mb-2 font-sans text-xs font-medium tracking-wide text-muted uppercase">
                {group}
              </h3>
              <ul className="flex flex-col gap-1.5">
                {commands.map((c) => (
                  <li key={c.id} className="flex items-center justify-between gap-3 text-sm">
                    <span className="text-ink-2">
                      {c.label}
                      {c.when ? <span className="block text-xs text-faint">{c.when}</span> : null}
                    </span>
                    <span className="flex items-center gap-1.5">
                      {c.keys.map((k, i) => (
                        <span key={k} className="flex items-center gap-1.5">
                          {i > 0 ? <span className="text-xs text-faint">or</span> : null}
                          <Shortcut binding={k} />
                        </span>
                      ))}
                    </span>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
        {paletteOnly.length ? (
          <section className="mt-5 border-t border-line pt-4">
            <h3 className="mb-2 flex items-center gap-2 font-sans text-xs font-medium tracking-wide text-muted uppercase">
              No key: run these from the palette <Shortcut binding="$mod+k" />
            </h3>
            <ul className="grid gap-x-5 gap-y-1.5 text-sm text-ink-2 sm:grid-cols-2">
              {paletteOnly.map((c) => (
                <li key={c.id}>{c.label}</li>
              ))}
            </ul>
          </section>
        ) : null}
      </div>
      <p className="border-t border-line px-5 py-3 text-sm text-muted">
        Esc closes any dialog. Some keys work only on their own screen.
      </p>
    </Modal>
  );
}
